import React from 'react';
import Section13 from '../Section13';

function VJTicket(props: any) {
  return (
    <Section13
      {...props}
      airline="VJ"
    />
  );
}

export default React.memo(VJTicket);
